import * as React from 'react';
import { useState, useEffect } from "react";
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { styled, useTheme, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, collection, onSnapshot, query, where, addDoc, orderBy } from 'firebase/firestore'

// Connect to current firebase project
const firebaseApp = initializeApp({
    apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
    authDomain: "ambient-systems.firebaseapp.com",
    databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "ambient-systems",
    storageBucket: "ambient-systems.appspot.com",
    messagingSenderId: "1001740093061",
    appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
  });
const firestore = getFirestore(firebaseApp);

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 250;

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(2),
      width: 'auto',
    },
  }));
  
  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));
  
  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '70ch',
      },
    },
  }));

  const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));

export default function MarketplaceConstructionPage() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [filter, setFilter] = useState("");
    const [word, setWord] = useState("");
    const [key, setKey] = useState("");
    const [market, setMarket] = useState([]);
    const [expanded, setExpanded] = useState({});

    useEffect(() => {
        var marketQuery = query(
          collection(firestore, 'marketplace'),
          where("type", "==", "Construction")
        );
        if (key) {
          marketQuery = query(
            collection(firestore, 'marketplace'),
            where("type", "==", "Construction"),
            where("title", ">=", key)
          );
        }
        if (filter) {
          marketQuery = query(
            collection(firestore, 'marketplace'),
            where("type", "==", "Construction"),
            where(filter, ">=", key)
          );
        }
        
        const unsubscribe = onSnapshot(marketQuery, snapshot => {
            setMarket(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
        })
    
        return () => {
            unsubscribe()
        }
      }, [key])
    
    const handleExpandClick = (id) => {
        setExpanded({
          ...expanded,
          [id]: !expanded[id]
        });
    }

    return (
        <Box sx={{ display: 'flex', height: '100%'}}>
            {/* Side bar layout */}
            <Drawer variant="permanent" open={open} >
                <Toolbar
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    height: 66,
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                        {open ?<KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                </Toolbar>

                <Divider />

                {/* Navigations to different pages */}
                <List component="nav">
                    <ListItemButton href="/Dashboard/Marketplace">
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Retrofit technologies" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/Marketplace/DER">
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="DER technologies" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/Marketplace/Construction">
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Construction materials" />
                    </ListItemButton>
                </List>
            </Drawer>
                    
            <Box sx={{ width: '100%' }}>
                {/* Title */}
                <Typography
                    component="h1"
                    variant="subtitle1"
                    color="inherit"
                    noWrap
                    sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                    >
                    Ambient / Marketplace / Construction materials
                </Typography>
                <Typography
                    component="h1"
                    variant="h4"
                    color="inherit"
                    noWrap
                    sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                    >
                    Construction materials
                </Typography>

                <Box sx={{ ml: 8, display: 'flex' }}>
                    <Select native defaultValue="" label="Select Attribute" size="small" disableUnderline onChange={(e) => {setFilter(e.target.value)}}>
                        <option aria-label="None" value="">FILTER</option>
                        <option value="uid">uid</option>
                        <option value="title">name</option>
                        <option value="price">price</option>
                        <option value="origin">origin</option>
                        <option value="material">material</option>
                        <option value="dimension">dimension</option>
                        <option value="company">company</option>
                        <option value="color">color</option>
                        <option value="brand">brand</option>
                        <option value="about">detail</option>
                    </Select>

                    <Search sx={{flexGrow: 0, borderRadius: 25}}>
                    <SearchIconWrapper>
                        <SearchIcon />
                    </SearchIconWrapper>
                    <StyledInputBase
                        placeholder="Search…"
                        inputProps={{ 'aria-label': 'search' }}
                        onChange={(e)=>{setWord(e.target.value)}}
                    />
                    </Search>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ borderRadius: 5, flexGrow: 0.1, mr: 5 }}
                        position="absolute"
                        onClick={() => {setKey(word)}}
                    >
                        Search
                    </Button>
                </Box>

                <Box sx={{ pl: '30%' }}>
                    {market?.map((item) => (
                    <Card sx={{ width: '40%' }}>
                        <CardHeader sx={{ height: 10 }}/>
                        <CardMedia
                        component="img"
                        height="200"
                        image={item.data.pic}
                        />
                        
                        <CardContent>
                        <FormControl sx={{ m: 2, width: 1000 }} variant= "standard">
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>Name: {item.data.title}</Typography>
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>Price: {item.data.price}</Typography>
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>Origin: {item.data.origin}</Typography>
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>Type: {item.data.type}</Typography>
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>URL: <a href={item.data.url}>{item.data.url}</a></Typography>
                        </FormControl>
                        </CardContent>
                        
                        <CardActions disableSpacing>
                        <IconButton aria-label="add to favorites">
                            <FavoriteIcon />
                        </IconButton>
                        <IconButton aria-label="share">
                            <ShareIcon />
                        </IconButton>
                        <ExpandMore
                            expand={expanded[item.data.id]}
                            onClick={() => {handleExpandClick(item.data.id)}}
                            // aria-expanded={expanded}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon />
                        </ExpandMore>
                        </CardActions>
                        <Collapse in={expanded[item.data.id]} timeout="auto" unmountOnExit>
                        <CardContent>
                            <FormControl sx={{ m: 2, maxWidth: 1000 }} variant= "standard">
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>Serial Number: {item.data.uid}</Typography>
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>Brand: {item.data.brand}</Typography>
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>Company: {item.data.company}</Typography>
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>Color: {item.data.color}</Typography>
                            <Typography variant="body1" color="text.primary" sx={{ mb: 1 }}>Material: {item.data.material}</Typography>
                            <Typography variant="body1" color="text.primary" sx={{ mb: 2 }}>Dimension: {item.data.dimension}</Typography>
                            <Typography paragraph>Detail: {item.data.about}</Typography>
                            
                            </FormControl>
                        </CardContent>
                        </Collapse>
                    </Card>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}